import React, { useEffect, useState } from "react";
import SEO from "../../data/seo";
import HeaderTwo from "../../layout/headers/header-two";
import BreadCrumb from "../common/breadcrumb";
import ContactMain from "./contact";
import FooterTwo from "../../layout/footers/footer-two";
import { getCMSContact } from "../../utils/cms.utils";

const ContactUs = () => {
    const [contact, setContact] = useState(null);

    useEffect(() => {
        const data = getCMSContact();
        setContact(data || null);
    }, []);

    // 🔒 SAFETY
    if (!contact) {
        return (
            <>
                <SEO pageTitle="Contact Us" />
                <HeaderTwo />
                <BreadCrumb title="Contact Us" items={[{ label: "Contact Us" }]} />
                <div className="section-padding text-center">
                    <p>Contact information is currently unavailable.</p>
                </div>
                <FooterTwo />
            </>
        );
    }

    const primaryOffice = contact.office?.[0];

    return (
        <>
            <SEO pageTitle="Contact Us" />
            <HeaderTwo />

            <BreadCrumb
                title="Contact Us"
                items={[{ label: "Contact Us" }]}
            />

            {/* MAIN CONTACT */}
            <ContactMain contact={contact} />

            {/* MAP (OFFICE PERTAMA) */}
            {primaryOffice?.embed && (
                <div className="map section-padding pt-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="map-area">
                                    <iframe
                                        src={primaryOffice.embed}
                                        loading="lazy"
                                        allowFullScreen
                                        referrerPolicy="no-referrer-when-downgrade"
                                        title={primaryOffice.address || "Office Location"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <FooterTwo />
        </>
    );
};

export default ContactUs;
